"use client";

import React, {useEffect, useRef} from "react";
import {cn} from "@/lib/utils";

declare global {
    interface Window {
        adsbygoogle?: Record<string, unknown>[];
    }
}

type AdSlotProps = {
    adSlot: string;
    className?: string;
    label?: string;
};

export function AdSlot({adSlot, className, label = "Advertisement"}: AdSlotProps) {
    const adRef = useRef<HTMLModElement>(null);
    const pushed = useRef(false);

    const pubId = process.env.NEXT_PUBLIC_ADSENSE_PUB_ID;

    useEffect(() => {
        if (!pubId || pushed.current) return;
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            pushed.current = true;
        } catch {
            // AdSense script not loaded yet (e.g. consent not granted)
        }
    }, [pubId]);

    if (!pubId) return null;

    return (
        <aside aria-label={label} className={cn("overflow-hidden", className)}>
            <ins
                ref={adRef}
                className="adsbygoogle"
                style={{display: "block"}}
                data-ad-client={pubId}
                data-ad-slot={adSlot}
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        </aside>
    );
}
